import url from 'url';
import {useLocation, useHistory} from 'react-router-dom';
import Select from '../common/formik/inputs/Select';
import {OptionsProp, QueryParamsProps} from '../../constants/types';
import {firstPage} from '../../constants/constants';
import {ChangeEvent} from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

type PaginationProps = {
  contentLength: number,
  totalElements: number;
  totalPages: number;
  pageNumber: number,
  query: QueryParamsProps
}

const options: OptionsProp[] = ['10', '20', '50', '100'].map((value) => ({
  value,
  label: value
}));

export const ListPagination = ({
  contentLength,
  totalElements,
  totalPages,
  pageNumber,
  query
}: PaginationProps) => {
  const history = useHistory();
  const {pathname, state} = useLocation();

  const itemsPerPage = query.per_page || options[0].value;

  const lowerBoundary = pageNumber === totalPages ?
    totalElements - contentLength + 1 : contentLength * (pageNumber - 1) + 1;
  const upperBoundary = pageNumber === totalPages ?
    totalElements : pageNumber * contentLength;

  const goToNextPage = () => {
    if (pageNumber !== totalPages) {
      history.push(
          url.format({
            pathname,
            query: {...query, page: pageNumber + 1}
          }), state);
    }
  };

  const goToPrevPage = () => {
    if (pageNumber !== 1) {
      history.push(
          url.format({
            pathname,
            query: {...query, page: pageNumber - 1}
          }), state);
    }
  };

  const changeRowsPerPage = ({
    target: {value}
  }: ChangeEvent<HTMLSelectElement>) => {
    history.push(
        url.format({
          pathname,
          query: {...query, per_page: value, page: firstPage}
        }), state);
  };

  if (!totalElements || pageNumber > totalPages) {
    return null;
  }

  return (
    <div className="pagination">
      <div className="rows-per-page">
        <Select
          name="rowCounter"
          label="Rows per page"
          options={options}
          onChange={changeRowsPerPage}
          value={itemsPerPage}
          size="small"
        />
      </div>
      <span className="rows-per-page total-records">
        {`${lowerBoundary} - ${upperBoundary} of ${totalElements}`}
      </span>
      <IconButton className="icon-button gray small" onClick={goToPrevPage}>
        <ArrowBackIosIcon className="icon" fontSize="small" />
      </IconButton>
      <IconButton className="icon-button gray small" onClick={goToNextPage}>
        <ArrowForwardIosIcon className="icon" fontSize="small" />
      </IconButton>
    </div>
  );
};
